<template>
  <div id="list-appointment">
    <div class='table-outer'>
      <table class="table table-light" border="1">
        <thead>
          <tr>
            <th>Tên cố vấn</th>
            <th>Dịch vụ cần tư vấn</th>
            <th>Câu hỏi</th>
            <th>Ngày hẹn</th>
            <th>Thời điểm trong ngày</th>
            <th>Trạng thái</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="appointment in list_appointments">            
            <td><a :href="'/counselor?id='+appointment.counselor_id" target="blank">{{appointment.counselor_name}}</a></td>
            <td>
              <div v-for="service in appointment.services">{{service.name}}</div>
            </td>
            <td data-toggle="tooltip" data-placement="top" :title=appointment.question>
              <div class="div-question">{{appointment.question}}</div>
            </td>
            <td>{{appointment.date_meeting}}</td>
            <td>{{appointment.time_of_the_day}}</td>            
            <td class='label-status-cell'>
              <div class='badge badge-pill label-status'
                :class="{
                  'badge-default': appointment.status=='requesting',
                  'badge-info': appointment.status=='approvaled' || appointment.status=='meeting',
                  'badge-success': appointment.status=='completed',
                  'badge-danger': appointment.status=='cancel'
                }">
                {{appointment.status}}
              </div>              
            </td>
            <td>
              <div class="button_group">
                <a v-if="appointment.status != 'completed'" class="btn btn-warning form-group" @click="update_status({id: appointment.id, status:'cancel'})">Cancel</a>
              </div>            
            </td>            
          </tr>               
        </tbody>
      </table>
    </div>
    <base-pagination      
      :pageCount="pagination.total_page"
      :value="current_page"
      @input="pagination.current_page=$event"
    ></base-pagination>
    <detail-appointment v-if="this.show_modal_detail_appointment"
    :show_modal_detail_appointment="show_modal_detail_appointment"
    @close_modal="show_modal_detail_appointment = $event"
    ></detail-appointment>
  </div>
</template>
<script>
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
  import DetailAppointment from '../Modal/DetailAppointmentModal.vue';
  export default{
    components:{
      DetailAppointment,
    },
    data: function(){
      return{
        show_modal_detail_appointment: false ,
        show_loading_modal: false,
      }
    },
    computed: {
      ...mapState('vuex_appointment',{        
        pagination: state => state.pagination_counselor_appointment,
        current_page: state => state.pagination_counselor_appointment.current_page,
        list_appointments: (state) => {
          return state.counselor_appointments
        },
        appointment_detail: state => state.appointment_detail,
      }) ,
    },
    watch: {
      current_page(new_value, old_value){
        if (old_value != undefined){
          this.$store.dispatch('vuex_appointment/get_counselor_appointments', new_value)
        }
      },    
    },
    methods: {
      update_status(data){
        this.show_loading_modal = true
        this.$store.dispatch('vuex_appointment/update_appointment', data)
        this.$store.dispatch('vuex_appointment/get_counselor_appointments', this.current_page)
        this.show_loading_modal = false
      }
    },
  };
</script>
<style lang="scss" scoped>
  @import "../Admin/list_appointment"
</style>


// WEBPACK FOOTER //
// src/views/components/MyAppointment/ListAppointmentCounselor.vue